"use client";
import React, { useState, useMemo } from "react";
import { DropdownContextTypes, DropdownWrapperProps } from "@stadium/ui/types/bootstrap-dropdown";

export const DropdownContext = React.createContext<DropdownContextTypes>(
  {} as DropdownContextTypes,
);

const DropdownWrapper = ({ children }: DropdownWrapperProps) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);

  const value = useMemo(
    () => ({
      isDropdownOpen,
      setIsDropdownOpen,
    }),
    [isDropdownOpen],
  );

  return <DropdownContext.Provider value={value}>{children}</DropdownContext.Provider>;
};

export default DropdownWrapper;
